const NFT = [
  {
    id: 1,
    image: require("../assets/images/1.png"),
    title: "YooBs",
    number: "17%",
  },
  {
    id: 2,
    image: require("../assets/images/2.png"),
    title: "YooBs",
    number: "17%",
  },
  {
    id: 3,
    image: require("../assets/images/3.png"),
    title: "YooBs",
    number: "17%",
  },
  {
    id: 4,
    image: require("../assets/images/4.png"),
    title: "YooBs",
    number: "17%",
  },
  {
    id: 5,
    image: require("../assets/images/5.png"),
    title: "YooBs",
    number: "17%",
  },
  {
    id: 6,
    image: require("../assets/images/6.png"),
    title: "YooBs",
    number: "17%",
  },
  {
    id: 7,
    image: require("../assets/images/7.png"),
    title: "YooBs",
    number: "17%",
  },
  {
    id: 8,
    image: require("../assets/images/8.png"),
    title: "YooBs",
    number: "17%",
  },
];

export default NFT;
